import messages from "@smartmixin/i18n/dist/translations/bg.json";

export default messages;
